import {LegalForm} from '@dms/api/customer';

import {Nullish} from 'shared/web';

import {getConsentContactPersonRequirement} from './getConsentContactPersonRequirement';

/**
 * Returns the contact person to send with a new consent. The API refuses a contact person
 * on a consent for a natural person.
 */
export const getConsentContactPersonId = (
  legalForm: LegalForm | Nullish,
  contactPersonId: string | Nullish
) =>
  getConsentContactPersonRequirement(legalForm) === 'hidden' ? null : (contactPersonId ?? null);
